module.exports = __webpack_public_path__ + "static/media/list-title-q.9135c24d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecturerInvite/list-title-q.png
// module id = 2029
// module chunks = 4